import { IResourceComponentsProps, useTranslate, useApiUrl, useNavigation } from '@pankod/refine-core';
import {
  Edit,
  Form,
  Input,
  InputNumber,
  Select,
  useForm,
  Row,
  Col,
  Checkbox,
  Button,
  Tabs,
} from '@pankod/refine-antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { User } from 'interfaces';
import { UserRoleEnum } from 'types/users/userRole';
import { EnumToArray } from 'util/parseData';
import { CustomTable, CustomTableProps } from 'components/data/customTable';
import React, { useEffect, useState } from 'react';
import UserHandler from 'util/UserHandler';
interface tabDataProps {
  address: CustomTableProps,
};

export const UserEdit: React.FC<IResourceComponentsProps> = () => {
    const { push } = useNavigation();
  const { formProps, saveButtonProps, queryResult } = useForm<User>({


    onMutationSuccess: () => {
    const editedUserId = queryResult?.data?.data?.id;
    if (editedUserId === UserHandler.getInstance().user.id) {
      push('/profile');
    } else {
      push('/users');
    }
  },
});

  const { TabPane } = Tabs;
  const apiUrl = useApiUrl();
  const t = useTranslate();
  const { edit } = useNavigation();
  const [newUserPhone, setNewUserPhone] = useState<string>();
  const [newUserEmail, setNewUserEmail] = useState<string>();
  const [tabItems, setTabItems] = useState<tabDataProps>({
    address: { columns: [], dataSource: [], config: { key: 'id', edit: null, delete: null } },
  });

  // Log state on every render
  console.log('UserEdit render, user_id:', queryResult?.data?.data?.id, 'tabItems.address:', tabItems.address);

  useEffect(() => {
    /**
     * user/address
     */
    if (queryResult?.data?.data?.id) {
      setNewUserEmail(formProps?.form?.getFieldValue('email'));
      setNewUserPhone(formProps?.form?.getFieldValue('phone'));
      const id = queryResult?.data?.data?.id;
      Promise.all([
        fetch(`${apiUrl}/user/address/user/${id}`, {
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${UserHandler.getInstance().token}` },
        }).then(res => res.json()),
      ]).then(responses => {
        if (responses[0].data) {
          const cols = [
            { title: t('fields.name', { ns: 'address' }), name: 'name', type: 'text', editable: true, required: false, table: 'address' },
            { title: t('fields.district', { ns: 'address' }), name: 'district', type: 'text', editable: true, required: true, table: 'address' },
            { title: t('fields.address', { ns: 'address' }), name: 'address', type: 'text', editable: true, required: true, table: 'address' },
            { title: t('fields.civic_number', { ns: 'address' }), name: 'civic_number', type: 'text', editable: true, required: true, table: 'address' },
            { title: t('fields.city_code', { ns: 'address' }), name: 'city_code', type: 'text', editable: true, required: true, table: 'address' },
            { title: t('fields.latitude', { ns: 'address' }), name: 'latitude', type: 'number', table: 'address' },
            { title: t('fields.longitude', { ns: 'address' }), name: 'longitude', type: 'number', table: 'address' },
          ];
          setTabItems(prevState => {
            const newTabItems = {
              ...prevState,
              address: {
                columns: cols,
                dataSource: responses[0].data,
                config: {
                  defaultPropsValues: { user_id: id },
                  table: 'address',
                  key: 'id',
                  edit: 'user/address',
                  delete: 'user/address',
                  addNew: { default: { user_id: id } },
                },
              },
            };
            return newTabItems;
          });
        }
      });
    }
  }, [queryResult?.data?.data?.id]);

  const newUserForm = () => {
    setNewUserEmail(formProps?.form?.getFieldValue('email'));
    setNewUserPhone(formProps?.form?.getFieldValue('phone'));
  };

  const generaPassword = () => {
    formProps?.form?.setFieldsValue({ password: Math.random().toString(36).slice(-8) });
  };

  const onFinish = () => {
    formProps?.form?.submit();
  };

  return (
    <Edit saveButtonProps={{ ...saveButtonProps, onClick: onFinish }}>
      <Tabs defaultActiveKey="1" key="tabs">
        <TabPane tab="Dati Utente" key="1">
          <Form
            {...formProps}
            //onFinish={onFinish}
            onFieldsChange={newUserForm}
            name="time_related_controls"
            layout="vertical"
          >
            <Form.Item hidden name="table">
              {' '}
              <Input type="hidden" />{' '}
            </Form.Item>
            <Row>
              <Col className="gutter-row" span={24}>
                <Form.Item name="newsletter" valuePropName="checked" noStyle>
                  <Checkbox>{t('fields.newsletter', { ns: 'users' })}</Checkbox>
                </Form.Item>
              </Col>
              <Col className="gutter-row" xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={t('fields.lastname', { ns: 'users' })}
                  name="lastname"
                  rules={[{ required: true, message: 'Please input lastname' }]}
                >
                  <Input maxLength={255} />
                </Form.Item>
              </Col>
              <Col className="gutter-row" xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={t('fields.firstname', { ns: 'users' })}
                  name="firstname"
                  rules={[{ required: true, message: 'Please input firstname' }]}
                >
                  <Input maxLength={255} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <Form.Item
                  label={t('fields.role', { ns: 'users' })}
                  name="role"
                  rules={[{ required: true }]}
                >
                  <Select options={EnumToArray(UserRoleEnum)} />
                </Form.Item>
              </Col>
              <Col className="gutter-row" xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={t('fields.email', { ns: 'users' })}
                  name="email"
                  rules={[
                    { type: 'email', message: 'The input is not valid E-mail!' },
                    { required: !newUserPhone, message: 'Please input email' },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col className="gutter-row" xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={t('fields.phone', { ns: 'users' })}
                  name="phone"
                  rules={[{ required: !newUserEmail, message: 'Please input phone' }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col className="gutter-row" xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  label={t('fields.language', { ns: 'users' })}
                  name="language"
                  rules={[{ required: true, message: 'Please input language' }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col className="gutter-row" xs={24} sm={12} md={12} lg={8} xl={8}>
                <Form.Item
                  label={t('fields.parent_user_id', { ns: 'users' })}
                  name="parent_user_id"
                >
                  <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col className="gutter-row" xs={24} sm={12} md={12} lg={8} xl={8}>
                <Form.Item
                  label={t('fields.total_votes', { ns: 'users' })}
                  name="total_votes"
                >
                  <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              <Col className="gutter-row" xs={24} sm={12} md={12} lg={8} xl={8}>
                <Form.Item
                  label={t('fields.ok_votes', { ns: 'users' })}
                  name="ok_votes"
                >
                  <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              {/*<Col className="gutter-row" xs={24} sm={12} md={12} lg={8} xl={8}>
                <Form.Item
                  label={t('fields.password', {ns: 'users'})}
                  rules={[{ required: true }]}
                  shouldUpdate={(prevValues, curValues) => prevValues.password !== curValues.password}
                >
                  {() => 
                    (
                      <Row>
                        <Col xs={21} sm={21} md={20} lg={20} xl={21}>
                          <Form.Item
                            name="password"
                            rules={[{ required: true, message: 'Please input password' }]}>
                            <Input.Password
                              iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={2} xl={1}>
                          <Button onClick={generaPassword}>Genera</Button>
                        </Col>
                      </Row>
                    )
                  }
                </Form.Item>
              </Col>*/}
            </Row>
          </Form>
        </TabPane>
        <TabPane tab={t('fields.indirizzi', { ns: 'users' })} key="2">
          <CustomTable {...tabItems.address} />
        </TabPane>
      </Tabs>
    </Edit>
  );
};